export default __webpack_public_path__ + "static/media/578.1050da36.png";